// extracted by mini-css-extract-plugin
module.exports = {"attachment_container":"GroupPostComponent_attachment_container__4jpdc"};